import { style } from '@vanilla-extract/css';

export const base = style({
  display: 'grid',
  gridAutoRows: 'min-content',
  maxWidth: '100%',
  width: '100%',
});
